import { useEffect } from "react";
var _asEffectCallback = function (fn) { return function () { return fn(); }; };
export var useOnMount = function (fn) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(_asEffectCallback(fn), []);
};
export var useOnBeforeUnmount = function (fn) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(function () { return _asEffectCallback(fn); }, []);
};
